export const editActions = <const>{
	NAKLADOVE_STREDISKO_MAPPER: 'NAKLADOVE_STREDISKO_MAPPER',
	LABOR_PRICE_MAPPER: 'LABOR_PRICE_MAPPER',
};

export const editMutations = <const>{
	UNSET_PPNR: 'unsetPPNr',
	PRACOVNI_POZICE_PPNR_SELECT_MAPPER: 'PRACOVNI_POZICE_PPNR_SELECT_MAPPER',
	PRACOVNI_POZICE_TABLPOZ_SELECT_MAPPER: 'PRACOVNI_POZICE_TABLPOZ_SELECT_MAPPER',
	PRACOVNIK_SELECT_MAPPER: 'PRACOVNIK_SELECT_MAPPER',
	NAKLADOVE_STREDISKO_MAPPER: 'NAKLADOVE_STREDISKO_MAPPER',
};
